/***** SCRIPTS POUR GERER LES FORMULAIRES *****/

  let nbChampVide = 0;
  let nbChampVideNewslet = 0;
  $("document").ready(setupForms);
  
  function setupForms() {
    customFileInputs();
    $('.wpcf7-form input[type="submit"], .wpcf7-form .wpcf7-submit').click(testerFormulaire);
    // $('#newsletterForm button[type="submit"]').click(testNewsletterForm);
  }
  
  // Fonction qui permet de vérifier les fichiers à envoyer
  function customFileInputs() {
    document.getElementById("fileinput");
      document.getElementById("file-chosen");
  
    $('input[type="file"]').on("change", function () {
      const splitFileName = this.value.split(".");
      const splitName = this.value.split("\\");
      const fileType = splitFileName[splitFileName.length - 1].toLowerCase();
  
      if (
        fileType === "jpg" ||
        fileType === "jpeg" ||
        fileType === "png" ||
        fileType === "pdf" ||
        fileType === "docx" ||
        fileType === "doc" ||
        fileType === "xlsx"
      ) {
        if (this.files[0].size > 2000000) {
          $(this).parent().children(".error-file").fadeOut(300);
          $(this)
            .parent()
            .children(".error-file")
            .html(
              "La taille du fichier dépasse 2Mo. Veuillez essayer avec un fichier qui fait moins de 2 MB."
            );
          $(this).parent().children(".error-file").fadeIn(300);
          $(this)
            .parent()
            .find("#file-chosen")
            .html("Aucun fichier selectionné.");
          $(this).val("");
        } else {
          $(this)
            .parent()
            .find("#file-chosen")
            .html(splitName[splitName.length - 1]);
          $(this).parent().children(".error-msg").fadeOut(300);
        }
      } else {
        $(this).parent().children(".error-file").fadeOut(300);
        $(this)
          .parent()
          .children(".error-file")
          .html(
            "Le format du fichier envoyé n'est pas autorisé. <br/>Veuillez essayer avec un format autorisé (pdf, jpg, png, docx, doc, ou xlsx)."
          );
        $(this).parent().children(".error-file").fadeIn(300);
        $(this).parent().find("#file-chosen").html("Aucun fichier selectionné.");
        $(this).parent().children("input").val("");
      }
    });
  }
  
  // Fonction qui permet de tester les formulaires
  function testerFormulaire(e) {
    let fromId = $(this).parent().parent().parent().parent().attr("id");
    if (fromId === undefined)
      fromId = $(this).parent().parent().parent().parent().parent().attr("id");
  
    // vérification des saisies utilisateurs
    nbChampVide = 0;
    $("#" + fromId + " .error-msg").fadeOut(200);
    $("#" + fromId + " .error").removeClass("error");
    $("#" + fromId + " .valid").removeClass("valid");
  
    // On vérifie que l'utilisateur a coché les cases RGPD
    if ($("#" + fromId + ' input[name="acceptance"]').prop("checked") === false) {
      $("#" + fromId + ' input[name="acceptance"]')
        .parent()
        .parent()
        .parent()
        .parent()
        .children(".error-msg")
        .fadeIn(300);
      nbChampVide++;
    }
  
    // On vérifie s'il y a des boutons radios obligatoires
    $("#" + fromId + " .wpcf7-radio").each(function () {
      if ($(this).find("input:checked").length === 0) {
        $(this).addClass("error");
        $(this).parent().parent().children(".error-msg").fadeIn(300);
        nbChampVide++;
      } else {
        $(this).addClass("valid");
      }
    });
  
    // On vérifie s'il y a des select list obligatoire
    $("#" + fromId + " select.wpcf7-validates-as-required").each(function () {
      if (
        $(this).val() === "" ||
        $(this).val() === " " ||
        $(this).val() === "- Aucun -"
      ) {
        $(this).addClass("error");
        $(this).parent().children(".error-msg").fadeIn(300);
        nbChampVide++;
      } else {
        $(this).addClass("valid");
      }
    });
  
    // On vérifie la saisie des champs obligatoire
    $(
      "#" +
        fromId +
        " .wpcf7-form input.wpcf7-validates-as-required, #" +
        fromId +
        " .form input.wpcf7-validates-as-number, #" +
        fromId +
        " .wpcf7-form input.wpcf7-validates-as-number"
    ).each(function () {
      if ($(this).val() === "" || $(this).val() === " ") {
        // On vérifie que le champ n'est pas vide
        nbChampVide++;
        $(this).addClass("error");
        $(this).parent().children(".error-msg").fadeIn(300);
      } else {
        // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
        const name = $(this).attr("name");
        if (name === "email") {
          const regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;
          if (regex.test($(this).val()) === false) {
            nbChampVide++;
            $(this).addClass("error");
            $(this).parent().children(".error-msg").fadeIn(300);
          } else {
            $(this).addClass("valid");
          }
        } else if (name === "phone") {
          const regexPhone = /^((\+|00)(3|33)\s?|0)[1-7](\s?\d{2}){4}$/;
          if (regexPhone.test($(this).val()) === false) {
            nbChampVide++;
            $(this).addClass("error");
            $(this).parent().children(".error-msg").fadeIn(300);
          } else {
            $(this).addClass("valid");
          }
        } else {
          $(this).addClass("valid");
        }
      }
    });
  
    // On vérifie que les textarea requis sont renseignés
    $(
      "#" +
        fromId +
        " .form textarea.wpcf7-validates-as-required, #" +
        fromId +
        " .wpcf7-form textarea.wpcf7-validates-as-required"
    ).each(function () {
      if ($(this).val() === "" || $(this).val() === " ") {
        // On vérifie que le champ n'est pas vide
        nbChampVide++;
        $(this).addClass("error");
        $(this).parent().children(".error-msg").fadeIn(300);
      } else {
        // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
        $(this).addClass("valid");
      }
    });
  
    if (nbChampVide !== 0) {
      e.preventDefault();
      $("html, body").animate(
        { scrollTop: $("#" + fromId + " .error").offset().top - 100 },
        500
      );
    } else {
      $("body > .loading").addClass("show");
    }
  }
  
  // On vérifie la newsletter
  function testNewsletterForm(e) {
    nbChampVideNewslet = 0;
    $(".footer-newsletter .error-msg").fadeOut(300);
  
    // On vérifie qu'on a sélectionné au moins une newsletter
    if ($(this).parent().parent().find("input:checked").length === 0) {
      $(this)
        .parent()
        .parent()
        .children(".footer-newsletter-choose")
        .children(".error-msg")
        .fadeIn(300);
      nbChampVideNewslet++;
    }
  
    // On vérifie qu'on a renseigné un email valide
    const regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;
    if (
      $(this).parent().parent().find("#email_newsletter").val() === "" ||
      $(this).parent().parent().find("#email_newsletter").val() === " " ||
      regex.test($(this).parent().parent().find("#email_newsletter").val()) ===
        false
    ) {
      $(this).parent().parent().children(".error-msg").fadeIn(300);
      nbChampVideNewslet++;
    }
  
    if (nbChampVideNewslet !== 0) {
      e.preventDefault();
    } else {
      $(this)
        .parent()
        .parent()
        .find('input[name="botOrNotBot_newsletter"]')
        .val("imNotBot");
      $.ajax({
        type: "GET",
        url: $("#newsletterForm").attr("action"),
        data: $("#newsletterForm").serialize(), // serializes the form's elements.
        beforeSend: function () {
          $(".loading").addClass("show");
        },
        success: function (data) {
          $(".loading").removeClass("show");
          document.location.href = "/inscription-newsletter";
        },
        error: function () {
          $("#newsletterForm #fail").html(
            "Votre inscription n'a pas pu être validée, merci de réessayer."
          );
          $("#newsletterForm #fail").fadeIn(200);
        },
      });
    }
  }
